import ChangePassword from './re-password';
import ChangePasswordWithOTP from './re-password-with-otp';
import ChangePasswordWithToken from './re-password-with-token';

const CustomRePassword = {
    Root: ChangePassword,
    WithToken: ChangePasswordWithToken,
    WithOTP: ChangePasswordWithOTP,
    name: 'Custom change password account, forget password,...',
};

export default CustomRePassword;
